/* ty-launch.js: ספירה לאחור, מצב השידור, והנגן שנטען רק בלחיצה.
 * ---------------------------------------------------------------------------
 * נבנה 07.09.2026 לאירוע ההשקה של אפל (iPhone 18), ומשרת שני סקשנים:
 *   sections/ty-launch-bar.liquid  (הפס מעל הכותרת, בכל דפי האתר)
 *   sections/ty-launch.liquid      (עמוד האירוע)
 *
 * שלושה מצבים על השורש [data-ty-launch], בתכונה data-ty-state:
 *   before  לפני תחילת השידור, מוצגת ספירה לאחור
 *   live    מתחילת השידור ועד data-ty-end
 *   after   אחרי data-ty-end (ההקלטה)
 * הליקוויד קובע מצב ראשוני בשרת כדי שלא יהיה הבהוב, וה-JS מכריע סופית
 * לפי שעון הלקוח ומעדכן כל שנייה. 📌 הזמנים נכתבים כ-ISO עם היסט
 * (2026-09-09T20:00:00+03:00), ולכן Date.parse מחזיר את אותה שנייה בכל
 * אזור זמן. אין כאן שום הנחה על השעון המקומי של הלקוח.
 *
 * 🔴 הנגן: לפני הלחיצה אין ולו בקשה אחת ליוטיוב. ה-iframe נוצר רק בלחיצה,
 *    ומ-youtube-nocookie.com. זה מה שמאפשר להציג אותו לפני הסכמה לעוגיות.
 */
(function () {
  'use strict';

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function split(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    return {
      d: Math.floor(s / 86400),
      // 🔴 עמודת «ימים» ירדה 08.09.2026, בקשת יובל. השעות **צוברות** אותם,
      //    ולכן זו חלוקה בכל השארית ולא אחרי modulo של יממה. בלי זה יום
      //    שלם נעלם והלקוח רואה 3 שעות כשנשארו 27.
      //    ⚠️ `d` עדיין מחושב, כי הוא מזין את תווית «יום/ימים» שמוסתרת
      //       ב-CSS. הסרתו מכאן תפיל את `setText` על צומת שאינו קיים.
      h: Math.floor(s / 3600),
      m: Math.floor((s % 3600) / 60),
      s: s % 60
    };
  }

  function setText(el, v) { if (el && el.textContent !== v) el.textContent = v; }

  function initRoot(root) {
    var start = Date.parse(root.getAttribute('data-ty-start') || '');
    var end = Date.parse(root.getAttribute('data-ty-end') || '');
    var until = Date.parse(root.getAttribute('data-ty-until') || '');
    if (isNaN(start)) return;

    var cd = {
      d: root.querySelector('[data-ty-cd="d"]'),
      dl: root.querySelector('[data-ty-cd="dl"]'),
      h: root.querySelector('[data-ty-cd="h"]'),
      m: root.querySelector('[data-ty-cd="m"]'),
      s: root.querySelector('[data-ty-cd="s"]')
    };
    var daysWrap = root.querySelector('[data-ty-cd-days]');

    function stateAt(now) {
      if (now < start) return 'before';
      if (!isNaN(end) && now >= end) return 'after';
      return 'live';
    }

    function tick() {
      var now = Date.now();
      if (!isNaN(until) && now >= until) {
        root.setAttribute('hidden', '');
        root.setAttribute('data-ty-state', 'hidden');
        return false;
      }
      var st = stateAt(now);
      if (root.getAttribute('data-ty-state') !== st) root.setAttribute('data-ty-state', st);
      if (st === 'before') {
        var p = split(start - now);
        setText(cd.d, String(p.d));
        setText(cd.dl, p.d === 1 ? 'יום' : 'ימים');
        setText(cd.h, pad(p.h));
        setText(cd.m, pad(p.m));
        setText(cd.s, pad(p.s));
        if (daysWrap) daysWrap.hidden = p.d === 0;
      }
      return true;
    }

    if (tick()) {
      var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 1000);
    }
  }

  function play(btn) {
    var wrap = btn.closest('[data-ty-player]');
    if (!wrap || wrap.getAttribute('data-ty-loaded') === '1') return;
    var id = wrap.getAttribute('data-ty-video');
    if (!id) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
      '?autoplay=1&rel=0&playsinline=1&hl=he&cc_load_policy=1';
    f.title = wrap.getAttribute('data-ty-title') || 'Apple Event';
    f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen; web-share');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    wrap.setAttribute('data-ty-loaded', '1');
    wrap.appendChild(f);
    btn.setAttribute('hidden', '');
  }

  function init() {
    var roots = document.querySelectorAll('[data-ty-launch]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ty-play]') : null;
    if (!btn) return;
    e.preventDefault();
    play(btn);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
